import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-join-call',
  templateUrl: './join-call.component.html',
  styleUrl: './join-call.component.scss',
})
export class JoinCallComponent implements OnInit, AfterViewInit {
  displayTemplate: TemplateRef<any>;
  joincallform: FormGroup;
  micenabled: boolean = true;
  videoenabled: boolean = true;
  userPayload = {
    name: null,
    room_id: null,
    session_id: null,
    audio_status: null,
    video_status: null,
  };

  @ViewChild('joinCall') private joinCall: TemplateRef<any>;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.joincallform = this.fb.group({
      username: [null, Validators.required],
    });

    this.activatedRoute.params.subscribe((params: Params) => {
      this.userPayload.room_id = params['id'];
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userPayload.name = params['name'];
      this.userPayload.session_id = params['session_id'];
      this.userPayload.audio_status = !!params['audioStatus'];
      this.userPayload.video_status = !!params['videoStatus'];
      this.updateValues(this.userPayload);
    });
  }

  updateValues(data: any) {
    this.joincallform.patchValue({
      username: data.name,
    });
    this.micenabled = data.audio_status;
    this.videoenabled = data.video_status;
  }

  get joinFC() {
    return this.joincallform.controls;
  }

  ngAfterViewInit(): void {
    this.displayTemplate = this.joinCall;
    this.cd.detectChanges();
  }

  onSubmit(form: FormGroup) {
    if (form.invalid) {
      return;
    }

    this.router.navigate([`/room/${this.userPayload.room_id}`], {
      queryParams: {
        session_id: this.userPayload.session_id,
        name: form.value.username,
        audioStatus: this.micenabled,
        videoStatus: this.videoenabled,
      },
    });
  }
}
